import { ChangeDetectorRef, Injectable } from '@angular/core';
import * as Moment from 'moment';
import * as mTZ from 'moment-timezone';
import * as Highcharts from 'highcharts';
import * as moment from 'moment-timezone';

window.moment = Moment;
mTZ();

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  currentTimezone: string;
  offset: string;

  constructor() {
    this.currentTimezone = moment.tz.guess();
    Highcharts.dateFormats.Z = (time: number): string => moment.tz(time, this.currentTimezone).format('Z');
    this.timezoneChanged();
  }

  public timestampRangeFromCalendarData(rangeDates: Date[]): {from: number, until: number} {
    const from = moment.tz(rangeDates[0].toLocaleDateString('es-ES'), 'DD/MM/YYYY', this.currentTimezone).startOf('day').valueOf();
    const until = moment.tz(rangeDates[1].toLocaleDateString('es-ES'), 'DD/MM/YYYY', this.currentTimezone).endOf('day').valueOf();
    return { from, until };
  }

  public getAllTimezones(): { name: string }[] {
    return moment.tz.names().map(zoneName => ({name: zoneName}));
  }

  public guessTimezone(): void {
    this.currentTimezone = moment.tz.guess();
    this.timezoneChanged();
  }

  getCurrentTimezone(): string {
    return this.currentTimezone;
  }

  setTimezone(newTimezone: string): void {
    this.currentTimezone = newTimezone;
    this.timezoneChanged();
  }

  timezoneChanged(): void {
    this.offset = moment.tz(moment.utc(), this.currentTimezone).format('Z');
    Highcharts.setOptions(
      {
        time: {
          timezone: this.currentTimezone
        }
      }
    );
  }

}
